import { Injectable } from '@angular/core';

export interface RatingDetails {
  sapRating?: number;
  eiRating?: number;
  potentialSAPRating?: number;
  potentialEIRating?: number;
}

export type RatingColorClasses = {
  sapRatingColorClass: string;
  eiRatingColorClass: string;
  potentialSAPRatingColorClass: string;
  potentialEIColorClass: string;
};

@Injectable()
export class RatingColorService {

  // Map the rating to a color class
  private getColorClassForRating(rating?: number): string {
    if (rating === null || rating === undefined) {
      return 'energy-efficiency-unknown';
    }

    if (rating >= 92) return 'energy-efficiency-92-300';
    if (rating >= 81 && rating <= 91) return 'energy-efficiency-81-91';
    if (rating >= 69 && rating <= 80) return 'energy-efficiency-69-80';
    if (rating >= 55 && rating <= 68) return 'energy-efficiency-55-68';
    if (rating >= 39 && rating <= 54) return 'energy-efficiency-39-54';
    if (rating >= 21 && rating <= 38) return 'energy-efficiency-21-38';
    if (rating >= 1 && rating <= 20) return 'energy-efficiency-1-20';
    return 'energy-efficiency-unknown';
  }

  // Get the color classes for the ratings
  public getColorClasses(asset: RatingDetails): RatingColorClasses {
    return {
      sapRatingColorClass: this.getColorClassForRating(asset?.sapRating),
      eiRatingColorClass: this.getColorClassForRating(asset?.eiRating),
      potentialSAPRatingColorClass: this.getColorClassForRating(asset?.potentialSAPRating),
      potentialEIColorClass: this.getColorClassForRating(asset?.potentialEIRating),
    };
  }
}
